import { EMAIL_EVENT, IGetCustomerContentStatus, PACKAGE_TYPE } from '../interface/IPayload';
import { IAppProviderState } from '../interface/IAppProvider';

const initialState: IAppProviderState = {
    loggedInCustomerHouseholdsize: 0, //Household from GTI
    effectiveDate: undefined,
    salesComplete: false,
    selectedPaymentOption: undefined,
    terminationCompany: undefined,
    terminationRequested: undefined,
    terminationWhen: undefined,
    terms: [false, false, false, false],
    termsIsSubmitted: false,
    aboutYouData: {
        name: '',
        addr: '',
        phone: '',
        email: '',
        updateInfo: false
    },

    //customerContentStatus: -1, // -1 = No content insurance with Topdanmark. 0 = Has content insurance with Topdanmark, same address as given. 1 = Has content insurance with Topdanmark, different address from given
    customerContentStatus: {} as IGetCustomerContentStatus,
    isCustomer: undefined,
    section: new Map<string, any>(),
    contentBlocks: {},
    householdSize: 0, //household size selected on Householdscreen
    alreadyCovered: { value: false, index: -1 },
    notAlreadyCoveredReason: undefined,
    numberOfClaims: -1,
    claimTypeSelected: undefined,
    claimType: undefined,
    claimAmount: 0,
    claimValue: null,
    cloudBurst: {
        value: '',
        compensation: ''
    },
    cprNo: undefined,
    createPackage: null,
    telephone: '',
    selectedPackage: {
        packageName: PACKAGE_TYPE.STANDARD,
        quoteId: 0,
        productId: 0,
        monthlyPrice: 0,
        yearlyPrice: 0
    },
    // set on first page in flow
    address: {
        address: '',
        addressInfo: {
            zipCode: '',
            streetName: '',
            houseNumber: '',
            postalCodeName: '',
            supCityName: '',
            floor: '',
            door: ''
        },
        status: '',
        event: '',
        kvhxUrl: '',
        kvhx: undefined,
        inBBR: undefined
    },
    selectedDeductible: null,
    updatedCoverages: null,
    bankInfo: {
        accNumber: '',
        regNumber: ''
    },
    updatedExtraCoverages: [],
    hasError: false,
    initialState: true,
    emailEvent: EMAIL_EVENT.GENERAL_ERROR,
    stateChange: false,
    isLoading: false,
    prizeZero: false,
    emailSent: false,
    refreshFromCache: false,
    resourcesReady: false,
    bannerText: '',
    bannerHeader: '',
    overlayText: '',
    showBannerOverlay: false,
    hasEboksSubscription: false,
    giftCard: null,
    actualStep: 0,
    previousStep: 0,
    customerHasMarking: null,
    isLateLogin: false //used to set the accept flag in ReceiptScreen
};
export default initialState;
